export default __webpack_public_path__ + "static/media/shutterstock_228939415.37c7c9c6.png";